"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriesMenu = void 0;
require("../css/categories-menu.scss");
var CategoriesMenu = /** @class */ (function () {
    function CategoriesMenu() {
    }
    CategoriesMenu.init = function (activeItem) {
        var categories = $("#categories-menu .category-item");
        var numCategories = categories.length;
        if (numCategories == 0) {
            $("#slides-page").css("height", "100%");
            return;
        }
        //styles
        var colSize = 12 / numCategories;
        categories.addClass("col-sm-" + colSize);
        //preselect default item
        categories.removeClass("active-menu-item");
        $(categories.siblings("[data-category-id='" + activeItem + "']")).addClass("active-menu-item");
        categories.off("click");
        categories.on("click", function () {
            categories.removeClass("active-menu-item");
            $(this).addClass("active-menu-item");
        });
        //set current category
        CategoriesMenu.currentCategory = activeItem;
    };
    return CategoriesMenu;
}());
exports.CategoriesMenu = CategoriesMenu;
